module.exports = require("@fortawesome/react-fontawesome");